import { PaymentCard } from '@mews/framework';

import { changeCustomerValue, changePaymentCardType } from '../../../../../slices';
import { connectPaymentField } from '../../../../../utils/connectPaymentField';

export const inject = connectPaymentField({
    // @ts-expect-error $TSFixMeError: Parameter 'dispatch' implicitly has an 'any' type.
    mapAdditionalDispatchProps: (dispatch, { name }: $TSFixMe) => ({
        onChange: (e: $TSFixMe) => {
            const { value } = e.target;
            dispatch(changeCustomerValue({ key: name, value }));

            const card = PaymentCard.cardFromNumber(value);
            if (card) {
                dispatch(changePaymentCardType(card.type));
            }
        },
    }),
});
